module.exports = __webpack_public_path__ + "img/shopping.861b3af9.svg";